var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup467(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 15.197,
    height: 19.741,
    fill: "#9f9f9f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(-827 -946)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(827 946)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    transform: "translate(3646.271 106.531) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-2",
    "data-name": "Vector Smart Object",
    transform: "matrix(0, -1, 1, 0, 850, 2806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M8.383,19.457l6.4-5.528a1.173,1.173,0,0,0,.119-1.672,1.259,1.259,0,0,0-1.694-.117L8.8,15.953V1.185a1.2,1.2,0,0,0-2.4,0V15.953L1.984,12.141a1.272,1.272,0,0,0-1.694.117A1.189,1.189,0,0,0,.408,13.93l6.4,5.528a1.236,1.236,0,0,0,1.575,0Z",
    fill: "#9f9f9f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M862.258,2805.71a1.272,1.272,0,0,1-.117-1.694l3.812-4.413H851.184a1.2,1.2,0,0,1,0-2.4h14.769l-3.812-4.413a1.259,1.259,0,0,1,.117-1.694,1.173,1.173,0,0,1,1.672.119l5.527,6.4a1.232,1.232,0,0,1,.284.774,1.341,1.341,0,0,1-.284.8l-5.527,6.4a1.21,1.21,0,0,1-.913.408A1.107,1.107,0,0,1,862.258,2805.71Z",
    fill: "#9f9f9f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup467);
export default __webpack_public_path__ + "static/media/Group 467.649f447f944ddcd24d203c77c89f881a.svg";
export { ForwardRef as ReactComponent };